import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CommonDataService } from './../common-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { AccessGroupService } from './../access-group.service';
import { LambdaFunctionService } from '../../service/lambda-function.service';
import { Store } from '@ngrx/store';

declare var $: any;
declare var jQuery: any;
declare var toastr: any;

@Component({
    selector: 'app-fs-profile',
    templateUrl: './fs-profile.component.html',
    styleUrls: ['./fs-profile.component.scss']
})
export class FsProfileComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    @Input() forTeamCompo: boolean = true;
    profiles: any;
    modal = false;
    modal1: any;
    env: any;
    Profile: any;
    oldValue: any;
    fieldEdit = 0;
    profileId: number;
    id: number;
    getProfile = false;
    brand_identity: any;
    args: any;
    member_id: string;
    letter_format = 'Download Profile PDF (US Letter)';
    a4_format = 'Download Profile PDF (International A4)';
    image_content = 'Download Profile PNG';
    date_of_profile: any;
    organization_title: any;
    thinking_profile_heading: any;
    thinking_profile_message: any;
    download: any;
    share_my_profile: any;
    explain_my_profile: any;
    low_preference: any;
    high_preference: any;
    contrast: any;
    clarify: any;
    ideate: any;
    develop: any;
    implement: any;
    prefers_to: any;
    get_report: any;
    sign_up_with: any;
    guide: any;
    guides: any;
    short_guide: string;
    long_guide: string;
    downloadingPdf = false;
    selected_format = 'letter';
    selected_lang = 'en';
    pf_description = '';
    pf_eqn = '';
    pf_title = '';
    pf_email_hd = 'Profile Email:';
    gen_pdf: any = '';
    loader = false;
    file_type = 'PDF';
    guidesLang: any;
    download_txt = 'Download';
    roster_user_profile: any;
    fromGlobalSearch = false;

    private storeNgrx$: any;
    private accountNgrx$: any;
    private ngrxAccessGroup$: any;

    constructor(
        public accessgroup: AccessGroupService,
        public activatedRoute: ActivatedRoute,
        public router: Router,
        private location: Location,
        public http: HttpClient,
        public service: CommonDataService,
        private modalService: NgbModal,
        public lmda_service: LambdaFunctionService,
        public store: Store<any>
    ) {}

    ngOnInit() {
        this.storeNgrx$ = this.store.select<any>((state) => state.profile.account.default_profile);
        this.accountNgrx$ = this.store.select<any>((state) => state.profile.account);
        this.ngrxAccessGroup$ = this.store.select<any>((state) => state.profile.accessGroupData);
        localStorage.setItem('profile_slideshow', 'true');
        this.env = environment;

        if (this.router.url !== '/teams') {
            this.service.pf_selected_language.pipe(
                takeUntil(this.destroy$)
            ).subscribe((val) => {
                this.selected_lang = val;
                this.change_language(false);
            });
        }

        this.activatedRoute.params.pipe(
            takeUntil(this.destroy$)
        ).subscribe((params) => {
            if (params.id) {
                if (params.id.includes('gs=')) {
                    this.getPfUsingIdWithApi(params.id);
                } else {
                    this.getPfUsingId(params.id);
                }
            } else {
                this.getProfileData();
            }
        });

        // Redirect if access not permitted
        this.ngrxAccessGroup$.pipe(
            takeUntil(this.destroy$)
        ).subscribe((message) => {
            if (message) {
                this.Profile = message['main_menu']?.profile?.fs_thinking_profile;
                if (message['main_menu']?.profile?.fs_thinking_profile?.profile_graph !== true && Object.keys(message).length > 0) {
                    this.router.navigate(['/dashboard']);
                }
            }
        });

        setTimeout(() => {
            $('html,body').animate({
                scrollTop: $('.page-heading').offset()?.top
            }, 100);
        });

        this.profileLangList();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    cancel() {
        this.location.back();
    }

    printprofile() {
        $('.navbar-default').hide();
        $('body').addClass('print-body');
        window.print();
        $('.navbar-default').show();
        $('body').removeClass('print-body');
    }

    open(content: any, pf = '') {
        $('.pdf-modal').css('display', 'block');
        this.modal = true;
        if (pf !== '') {
            setTimeout(() => {
                $('.modal-dialog').addClass('pf-popup');
            });
        }
    }

    // --- Profile Data Loading ---

    getPfUsingId(id: string) {
        if (this.router.url.includes('member-profile') || this.router.url.includes('fs-profile-gs')) {
            const storageName = this.router.url.includes('member-profile') ? 'roster_user_profile' : 'fs-profile-gs';
            this.fromGlobalSearch = this.router.url.includes('fs-profile-gs');
            this.roster_user_profile = JSON.parse(localStorage.getItem(storageName));
            this.profiles = this.roster_user_profile;
            this.pf_description = this.profiles?.profile_description;
            this.pf_eqn = this.profiles?.profile_equation;
            this.pf_title = this.profiles?.profile_title;
            this.fetchTranslations(this.selected_lang, (data) => {
                this.applyTranslationData(data);
                this.oldValue = this.profiles;
                this.buildArgs(this.profiles);
            });
        } else {
            this.service.Profile().pipe(
                take(1),
                takeUntil(this.destroy$)
            ).subscribe((message) => {
                this.getProfile = !message?.length;
                for (let i = 0; i < message.length; i++) {
                    if (message[i].id == id) {
                        this.profiles = message[i];
                        this.profileId = message[i].id;
                        this.pf_description = message[i]?.profile_description;
                        this.pf_eqn = message[i]?.profile_equation;
                        this.pf_title = message[i]?.profile_title;
                        this.fetchTranslations(message[i]?.language?.short_name, (data) => {
                            this.applyTranslationData(data);
                            this.oldValue = message[i];
                            this.buildArgs(message[i]);
                        });
                        if (!this.profiles) {
                            this.fetchBrandIdentity();
                        }
                        break;
                    }
                }
            });
        }
    }

    getPfUsingIdWithApi(id: string) {
        this.fromGlobalSearch = true;
        this.roster_user_profile = JSON.parse(localStorage.getItem('fs-profile-gs'));
        this.profiles = this.roster_user_profile;
        this.pf_description = this.profiles?.profile_description;
        this.pf_eqn = this.profiles?.profile_equation;
        this.pf_title = this.profiles?.profile_title;
        this.fetchTranslations(this.selected_lang, (data) => {
            this.applyTranslationData(data);
            this.oldValue = this.profiles;
            this.buildArgs(this.profiles);
        });
    }

    getProfileData() {
        this.storeNgrx$.pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe((message) => {
            if (message) {
                this.getProfile = false;
                this.profiles = message;
                this.profileId = message.id;
                this.pf_description = this.profiles?.profile_description;
                this.pf_eqn = this.profiles?.profile_equation;
                this.pf_title = this.profiles?.profile_title;
                this.fetchTranslations(message?.language?.short_name, (data) => {
                    this.applyTranslationData(data);
                    this.oldValue = message;
                    this.buildArgs(message);
                });
                if (!this.profiles) {
                    this.fetchBrandIdentity();
                }
            } else {
                this.getProfile = true;
            }
        });
    }

    // --- Translation Helpers ---

    private fetchTranslations(langCode: string, onSuccess: (data: any) => void) {
        this.http.get(`${environment.profileURL}/api/v1/translations.json?language=${langCode}`, {
            params: { groups: 'Thinking Profile' }
        }).pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe({
            next: (data) => {
                if (Object.keys(data).length > 0) {
                    onSuccess(data);
                } else {
                    this.http.get(`${environment.profileURL}/api/v1/translations.json?language=${langCode}`).pipe(
                        take(1),
                        takeUntil(this.destroy$)
                    ).subscribe((fallbackData) => onSuccess(fallbackData));
                }
            },
            error: () => {
                this.setDefaultTranslations();
                this.buildArgs(this.profiles);
            }
        });
    }

    private setDefaultTranslations() {
        this.date_of_profile = 'Profile Date';
        this.organization_title = 'Organization';
        this.thinking_profile_heading = 'FourSight<sup>®</sup> Thinking Profile</span>';
        this.thinking_profile_message = 'measures where you gain energy in the innovation process. There are no "good" or "bad" scores. Each of these four preferences has its own strengths and potential weaknesses. The goal is not to change your preferences, but to understand how your preferences are affecting your decision making, your perceptions, your stress levels and your interactions with others.';
        this.download = 'Download';
        this.share_my_profile = 'Share my profile';
        this.explain_my_profile = 'Explain my profile';
        this.low_preference = 'Low Preference';
        this.high_preference = 'High Preference';
        this.contrast = 'Neutral';
        this.clarify = 'Clarify';
        this.ideate = 'Ideate';
        this.develop = 'Develop';
        this.implement = 'Implement';
        this.prefers_to = 'prefers to';
        this.get_report = 'Get your full report at';
        this.sign_up_with = 'Sign up with the email';
    }

    private applyTranslationData(data: any) {
        this.date_of_profile = data['date_of_profile'];
        this.organization_title = data['organization_title'];
        this.thinking_profile_heading = data['thinking_profile_heading'];
        this.thinking_profile_message = data['thinking_profile_message'];
        this.download = data['download'];
        this.share_my_profile = data['share_my_profile'];
        this.explain_my_profile = data['explain_my_profile'];
        this.low_preference = data['low_preference'];
        this.high_preference = data['high_preference'];
        this.contrast = data['contrast'];
        this.clarify = data['stage_clarify'];
        this.ideate = data['stage_ideate'];
        this.develop = data['stage_develop'];
        this.implement = data['stage_implement'];
        this.prefers_to = data['prefers_to'];
        this.get_report = data['get_report'];
        this.sign_up_with = data['sign_up_with'];
        this.download_txt = data['download'];
    }

    // Apply translation labels using non-stage keys (used by language change path)
    private applyLanguageLabels(data: any) {
        this.pf_email_hd = data['profile_email'];
        this.date_of_profile = data['date_of_profile'];
        this.organization_title = data['organization_title'];
        this.thinking_profile_heading = data['thinking_profile_heading'];
        this.thinking_profile_message = data['thinking_profile_message'];
        this.download = data['download'];
        this.share_my_profile = data['share_my_profile'];
        this.explain_my_profile = data['explain_my_profile'];
        this.low_preference = data['low_preference'];
        this.high_preference = data['high_preference'];
        this.contrast = data['contrast'];
        this.clarify = data['clarify'];
        this.ideate = data['ideate'];
        this.develop = data['develop'];
        this.implement = data['implement'];
        this.prefers_to = data['prefers_to'];
        this.get_report = data['get_report'];
        this.sign_up_with = data['sign_up_with'];
        this.download_txt = data['download'];
    }

    private fetchBrandIdentity() {
        this.accountNgrx$.pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe((res) => {
            this.member_id = res?.member?.id;
            if (this.member_id) {
                this.http.get(`${environment.profileURL}/api/v1/members/${this.member_id}.json`).pipe(
                    take(1),
                    takeUntil(this.destroy$)
                ).subscribe((result) => {
                    this.brand_identity = result['member']['brand_identity'];
                });
            }
        });
    }

    // --- Args Building ---

    private buildArgs(message: any) {
        if (!message) return;
        this.args = {
            date_title: message['date_of_profile'],
            email_title: message['profile_email'],
            id: message['id'],
            content_type: 'pdf',
            personalized_note: `Get personalized results at <a href="${this.env.lambda_pf_footer}/thinking-coach"> ${this.env.lambda_pf_footer}/thinking-coach</a> with the email ${message['email']}`,
            template: 'profile.html',
            email: message['email'],
            date_of_profile: this.date_of_profile,
            organization_title: this.organization_title,
            first_name: message['first_name'],
            last_name: message['last_name'],
            low_preference: this.low_preference,
            high_preference: this.high_preference,
            contrast: this.contrast,
            clarify: this.clarify,
            ideate: this.ideate,
            develop: this.develop,
            implement: this.implement,
            prefers_to: this.prefers_to,
            get_report: this.get_report,
            sign_up_with: this.sign_up_with,
            thinking_profile_heading: this.thinking_profile_heading,
            thinking_profile_message: this.thinking_profile_message,
            organization: message['organization_name'],
            clarifier_sum: message['clarifier_sum'],
            developer_sum: message['developer_sum'],
            ideator_sum: message['ideator_sum'],
            implementer_sum: message['implementer_sum'],
            low_contrast: message['low_contrast'],
            high_contrast: message['high_contrast'],
            generated_at: message['generated_at'],
            profile_title: message?.profile_title,
            profile_equation: message['profile_equation'],
            profile_description: message['profile_description'],
            profile_type_id: message['profile_type_id'],
        };
    }

    private buildArgsFromTranslation(data: any, message: any, pfDesc: string, pfEqn: string, pfTitle: string) {
        if (!message) return;
        this.args = {
            date_title: data?.date_of_profile,
            email_title: data?.profile_email,
            id: message['id'],
            content_type: 'pdf',
            personalized_note: `Get personalized results at <a href="${this.env.lambda_pf_footer}/thinking-coach"> ${this.env.lambda_pf_footer}/thinking-coach</a> with the email ${message['email']}`,
            template: 'profile.html',
            email: message['email'],
            date_of_profile: data['date_of_profile'],
            organization_title: data['organization_title'],
            first_name: message['first_name'],
            last_name: message['last_name'],
            low_preference: data['low_preference'],
            high_preference: data['high_preference'],
            contrast: data['contrast'],
            clarify: data['clarify'],
            ideate: data['ideate'],
            develop: data['develop'],
            implement: data['implement'],
            prefers_to: data['prefers_to'],
            get_report: data['get_report'],
            sign_up_with: data['sign_up_with'],
            thinking_profile_heading: data['thinking_profile_heading'],
            thinking_profile_message: data['thinking_profile_message'],
            organization: message['organization_name'],
            clarifier_sum: message['clarifier_sum'],
            developer_sum: message['developer_sum'],
            ideator_sum: message['ideator_sum'],
            implementer_sum: message['implementer_sum'],
            low_contrast: message['low_contrast'],
            high_contrast: message['high_contrast'],
            generated_at: message['generated_at'],
            profile_title: pfTitle,
            profile_equation: pfEqn,
            profile_description: pfDesc,
            profile_type_id: message['profile_type_id'],
        };
    }

    // --- Profile Language List ---

    profileLangList() {
        this.http.get(`${environment.assessment_admin}api/v1/interpretive_guides`).pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe((data) => {
            this.guidesLang = data['interpretive_guides'].sort((a, b) =>
                a.language_name.localeCompare(b.language_name)
            );
        });
    }

    // --- Edit Profile Name ---

    editField() {
        this.fieldEdit = 1;
    }

    cancelField() {
        this.fieldEdit = 0;
        this.profiles.first_name = this.oldValue.first_name;
        this.profiles.last_name = this.oldValue.last_name;
    }

    changeProfileName() {
        this.http.patch(
            `${environment.profileURL}/api/v1/profiles/${this.profileId}/update_info.json?first_name=${this.profiles.first_name}&last_name=${this.profiles.last_name}`,
            ''
        ).pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe({
            next: () => {
                this.fieldEdit = 0;
                this.showToast('Your profile name has been updated successfully!');
                this.storeNgrx$.pipe(
                    take(1),
                    takeUntil(this.destroy$)
                ).subscribe((message) => {
                    if (message) {
                        this.profiles = message;
                        this.buildArgs(message);
                    }
                });
            },
            error: (error) => {
                this.fieldEdit = 0;
                this.showToast(error.error?.errors || 'Update failed', 'Oops!', 'error');
            }
        });
    }

    // --- PDF Generation ---

    async lambdaPDF(format: string, title: string, type: string) {
        this.lmda_service.lambda_res.next([]);
        this.loader = true;
        const date = new Date();
        this.downloadingPdf = true;
        const pdfFilename = 'foursight-profile-' + this.args.first_name + '-' + this.args.last_name + '-' + date.getFullYear().toString().substr(-2) + date.getMonth() + date.getDate();

        if (type === 'pdf') {
            this.args.content_type = 'pdf';
            this.args.format = format;
            if (format === 'A4') {
                this.a4_format = 'Generating Profile PDF...';
            } else {
                this.letter_format = 'Generating Profile PDF...';
            }
        } else {
            this.image_content = 'Generating Profile PNG...';
            this.args.content_type = 'png';
        }

        this.args.template = 'profile.html';
        await this.lmda_service.lambda_invoke('genr-InvoiceFunction-sZf7W6rjtE0H', this.args);
        this.lmda_service.lambda_res.pipe(
            takeUntil(this.destroy$)
        ).subscribe((val) => {
            if (val) {
                this.gen_pdf = val;
                this.loader = false;
            }
        });

        this.letter_format = 'Download Profile PDF (US Letter)';
        this.a4_format = 'Download Profile PDF (International A4)';
        this.image_content = 'Download Profile PNG';
        this.downloadingPdf = false;
    }

    selectFormat(fileType: string, format: string) {
        this.gen_pdf = '';
        this.file_type = fileType;
        this.selected_format = format;
    }

    profile_downloader() {
        if (this.selected_format === 'A4') {
            this.lambdaPDF('A4', 'Download Profile PDF (International A4)', 'pdf');
        } else if (this.selected_format === 'letter') {
            this.lambdaPDF('Letter', 'Download Profile PDF (US Letter)', 'pdf');
        } else {
            this.lambdaPDF('Letter', 'Download Profile PNG', 'png');
        }
    }

    // --- Guides ---

    getGuides(content: any) {
        this.guide = '';
        // Reuse cached guides if already fetched by profileLangList
        if (this.guidesLang) {
            this.guides = this.guidesLang;
            this.modal1 = this.modalService.open(content, { windowClass: 'in grey' });
        } else {
            this.http.get(`${environment.assessment_admin}api/v1/interpretive_guides`).pipe(
                take(1),
                takeUntil(this.destroy$)
            ).subscribe((data) => {
                this.guides = data['interpretive_guides'].sort((a, b) =>
                    a.language_name.localeCompare(b.language_name)
                );
                this.guidesLang = this.guides;
                this.modal1 = this.modalService.open(content, { windowClass: 'in grey' });
            });
        }
    }

    changeGuide() {
        for (let i = 0; i < this.guides?.length; i++) {
            if (this.guides[i].language_code === this.guide) {
                this.short_guide = this.guides[i].short_guide;
                this.long_guide = this.guides[i].long_guide;
                break;
            }
        }
    }

    // --- Language Change ---

    change_language(lang_update = true) {
        this.gen_pdf = '';
        if (lang_update) {
            this.service.pf_selected_language.next(this.selected_lang);
        }

        // Fetch profile type descriptions for selected language, then translations
        this.http.get(`${environment.profileURL}/api/v1/profile_types.json`, {
            params: { profile: 'custom', language: this.selected_lang }
        }).pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe((res) => {
            const profileTypes = res['profile_types'] || [];
            let pfDesc = this.pf_description;
            let pfEqn = this.pf_eqn;
            let pfTitle = this.pf_title;

            for (const pt of profileTypes) {
                if (this.profiles?.profile_title === pt['type']) {
                    this.pf_description = pt['individual_description'];
                    this.pf_eqn = pt['profile_equation'];
                    this.pf_title = pt['profile_title'];
                    pfDesc = pt['individual_description'];
                    pfEqn = pt['profile_equation'];
                    pfTitle = pt['profile_title'];
                    break;
                }
            }

            // Fetch translations and rebuild args with resolved profile type data
            const profileData = this.profiles;
            this.fetchTranslationsForLang(this.selected_lang, profileData?.language?.short_name, (data) => {
                this.applyLanguageLabels(data);
                if (profileData) {
                    this.buildArgsFromTranslation(data, profileData, pfDesc, pfEqn, pfTitle);
                }
            });
        });
    }

    private fetchTranslationsForLang(selectedLang: string, fallbackLang: string, onSuccess: (data: any) => void) {
        this.http.get(`${environment.profileURL}/api/v1/translations.json?language=${selectedLang}`, {
            params: { groups: 'Thinking Profile' }
        }).pipe(
            take(1),
            takeUntil(this.destroy$)
        ).subscribe((data) => {
            if (Object.keys(data).length > 0) {
                onSuccess(data);
            } else {
                this.http.get(`${environment.profileURL}/api/v1/translations.json?language=${fallbackLang}`).pipe(
                    take(1),
                    takeUntil(this.destroy$)
                ).subscribe((fallbackData) => onSuccess(fallbackData));
            }
        });
    }

    // --- Scroll ---

    quickGuide() {
        setTimeout(() => {
            $('html,body').animate({
                scrollTop: $('.fn-profile.section-padding').offset()?.top
            }, 'slow');
        }, 100);
    }

    // --- Toast Helper ---

    private showToast(message: string, title = 'Nice!', type: 'success' | 'error' | 'warning' = 'success') {
        setTimeout(() => {
            toastr.options = { closeButton: true, progressBar: true, timeOut: 2000 };
            toastr[type](message, title);
        }, 1000);
    }
}
